import BulkColisScanner from "@/components/colis/BulkColisScanner";
import PickUpConfirmationDialog from "@/components/dialogs/PickUpConfirmationDialog";
import ActionButton from "@/components/loader-button/ActionButton";
import { Toaster } from "@/components/ui/toaster";
import { useBulkPickUpValidation } from "@/hooks/useBulkPickUpValidation";
import React from "react";

const BulkPickUpValidationPage: React.FC = () => {
  const {
    isAllowedRole,
    colisList,
    scannedColisItems,
    scannedCount,
    expectedColisCount,
    tourneeCount,
    isSessionStarted,
    isScanning,
    isValidating,
    isValidationDisabled,
    handleScan,
    handleValidation,
  } = useBulkPickUpValidation();

  if (!isAllowedRole) {
    return null;
  }

  return (
    <div className="flex flex-col h-full gap-4">
      <BulkColisScanner
        sessionReturns={colisList}
        scannedColisItems={scannedColisItems}
        scannedCount={scannedCount}
        expectedColisCount={expectedColisCount}
        tourneeCount={tourneeCount}
        isSessionStarted={isSessionStarted}
        isScanning={isScanning}
        onScan={handleScan}
      />
      <div className="px-4 flex space-x-4 flex-row">
        <ActionButton
          loading={isValidating}
          disabled={isValidationDisabled}
          handleClick={handleValidation}
          label="Valider le ramassage"
        />
      </div>
      <Toaster />
      <PickUpConfirmationDialog handleValidate_={handleValidation} />
    </div>
  );
};

export default BulkPickUpValidationPage;
